import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Flex, Form, InputNumber, Tooltip, Typography } from 'antd'
import { GoldenTicketType } from 'Modules'

import DatePicker from 'component/date-picker/date-picker'

const { Text } = Typography

interface RarityItemSetupProps {
  name: number
  ticket: GoldenTicketType
}

export const RarityItemSetup = ({ name, ticket }: RarityItemSetupProps) => {
  return (
    <Flex gap={12} className="rewards-create__rarity-item">
      <Flex
        justify="space-between"
        align="flex-end"
        className="rewards-create__rarity-item-content"
      >
        <Flex vertical>
          <Text ellipsis title={ticket.name} className="rewards-create__rarity-item-label">
            {ticket.name}
          </Text>
          <div className="rewards-create__rarity-item-tickets">{ticket.quantity} tickets</div>
        </Flex>

        <Flex align="flex-end" gap={8}>
          <Form.Item
            name={[name, 'amount']}
            label={
              <>
                Reward Amount
                <Tooltip
                  title={
                    <div className="tooltip-box">
                      <p className="tooltip-text">
                        {`Total reward amount for this ticket program.\nLeave
                      empty to skip this program.`}
                      </p>
                    </div>
                  }
                  placement="right"
                >
                  <QuestionCircleOutlined className="tooltip-icon" />
                </Tooltip>
              </>
            }
            rules={[
              {
                type: 'number',
                min: 0.01,
                message: 'Amount must be greater than 0',
              },
            ]}
            className="rewards-create__rarity-item-form-item"
          >
            <InputNumber
              className="rewards-create__rarity-amount"
              min={0.01}
              disabled={ticket.inRewardPool}
              placeholder="Enter amount"
              addonBefore="$"
            />
          </Form.Item>
        </Flex>
      </Flex>

      <Form.Item
        className="rewards-create__rarity-item-form-item rewards-create__rarity-item-form-item--activation"
        label={
          <>
            Activation Date & Time
            <Tooltip
              title={
                <div className="tooltip-box">
                  <p className="tooltip-text">
                    {`When this reward will be activated and available.\nIf empty, current date & time will be used.`}
                  </p>
                </div>
              }
              placement="right"
            >
              <QuestionCircleOutlined className="tooltip-icon" />
            </Tooltip>
          </>
        }
        name={[name, 'activationDate']}
      >
        <DatePicker
          disabled={ticket.inRewardPool}
          className="rewards-create__rarity-item-datepicker"
          showTime={{ format: 'HH:mm' }}
        />
      </Form.Item>

      {ticket.inRewardPool && (
        <div style={{ width: '100%' }}>
          <Flex gap={4} className="rewards-create__rarity-item-warning">
            <InfoCircleOutlined className="rewards-create__rarity-item-warning-icon" />
            This ticket already has a reward. Delete the existing reward to create a new one.
          </Flex>
        </div>
      )}
    </Flex>
  )
}
